import { CommonModule } from '@angular/common'
import { Component, Inject, ViewChild } from '@angular/core'
import { EditorComponent } from '@app/modules/shared/components/editor/editor.component'
import { NB_DIALOG_CONFIG, NbDialogRef } from '@nebular/theme'

export interface CommentModalContext {
  commentContent?: string
  color?: string
}

@Component({
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.component.html',
  styleUrls: ['./comment-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, EditorComponent]
})
export class CommentModalComponent {
  @ViewChild(EditorComponent) editor: EditorComponent
  commentContent: string = ''

  constructor(
    @Inject(NB_DIALOG_CONFIG) public context: CommentModalContext,
    protected dialogRef: NbDialogRef<CommentModalComponent>
  ) {
    this.commentContent = context?.commentContent || ''
  }

  cancel() {
    this.dialogRef.close()
  }

  save() {
    // EditorComponent emits HTML via valueChange, so commentContent already contains HTML
    this.dialogRef.close({ comment: this.commentContent })
  }
}
